import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import AppActions from '../../app/app_actions';
import * as agui from 'arm-gui/dist/controls';
import { Utils, UiUtils, NumberFormatter, DateFormatter, i18n, isAuth } from 'arm-common';
import { isNullOrUndefined } from 'util';
import PacchettoCard from './pacchettoCard.jsx';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import ProdottoActions from './prodotto_actions';



class ListaPacchetto extends React.Component {

    constructor(props) {
        super(props);
        this.componentName = '[ListaLinea.jsx] ';
        this.state = {
            idPacchettoDaEliminare: null,
            validation: new Map()
        }
        this.onClickEliminaPacchetto = this.onClickEliminaPacchetto.bind(this);
        this.onClickModificaPacchetto = this.onClickModificaPacchetto.bind(this);
        this.onClickAnnullaModifica = this.onClickAnnullaModifica.bind(this);
        this.onClickSalvaPacchetto = this.onClickSalvaPacchetto.bind(this);
        this.onClickNuovoPacchettoButton = this.onClickNuovoPacchettoButton.bind(this);
        this.showPopUP = this.showPopUP.bind(this);
        this.returnToPath = this.returnToPath.bind(this);
        this.validateForm = this.validateForm.bind(this);
    }

    
    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');
    }

 
    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');
    }

    //imposta il campo disabled a false per l'linea index della lista
    onClickModificaPacchetto(event) {
        console.log(this.componentName + ' onClickModificaPacchetto');
        if (isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) {
            return
        }
        let indexPacchetto = event.currentTarget.id;
        let Pacchetto = this.props.listProdottoPacchetto[indexPacchetto];
        if (Pacchetto) {
            this.props.handleChangeEditPacchetto(indexPacchetto, "editable", true)
          
        }
    }

    //imposta il campo disabled a true per l'linea index della lista
    onClickAnnullaModifica(event) {
        console.log(this.componentName + ' onClickAnnullaModifica');
        if (isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) {
            return
        }
        let indexPacchetto = event.currentTarget.id;
        this.props.handleChangeEditPacchetto(indexPacchetto, "editable", false).then(
            resolve => {
                console.log(this.componentName + 'after delete linea, reload Linea ');
                this.setState({ validation: new Map() });
                //l'idProdotto è sempre lo stesso su tutti gli Linea quindi prendo il primo
                this.props.getListPacchetti(this.props.prodotto.id);
            }, reject => {
                console.log(this.componentName + ' deletePacchetto KO');
            });
    }

    onClickEliminaPacchetto(event) {
        console.log(this.componentName + ' onClickEliminaPacchetto');
        this.props.showPopUP(false);
        let idPacchetto = this.state.idPacchettoDaEliminare;
        this.props.deletePacchetto(idPacchetto).then(
            resolve => {
                console.log(this.componentName + 'after delete linea, reload Linea list');
                $('html, body').animate({ scrollTop: 0 }, 1000);
                //l'idProdotto è sempre lo stesso su tutti gli Linea quindi prendo il primo
                this.props.getListPacchetti(this.props.prodotto.id);
            }, reject => {
                console.log(this.componentName + ' deletePacchetto KO');
                $('html, body').animate({ scrollTop: 0 }, 1000);
            });
    }

    onClickSalvaPacchetto(event) {
        console.log(this.componentName + ' onClickSalvaPacchetto');
        if (isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) {
            return
        }
        let indexPacchetto = event.currentTarget.id;
        let ProdottoPacchetto = this.props.listProdottoPacchetto[indexPacchetto];
        if (this.validateForm(indexPacchetto)) {
            if(ProdottoPacchetto && ProdottoPacchetto.listProdottoPacchettoLinea.length == 0){
            this.props.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTO.QUOTA_NON_PUO_ESSERE_MAGGIORE_DI_100', 'Nessuna linea assocciata'));
            $('html, body').animate({ scrollTop: 0 }, 1000);
            return;
        }
            this.props.salvaPacchetto(indexPacchetto).then(
                resolve => {
                    console.log(this.componentName + 'after delete pacchetto, reload pacchetto ');
                    this.props.getListPacchetti(this.props.prodotto.id);
                }, reject => {
                    console.log(this.componentName + ' salvaPacchetto KO');
                    $('html, body').animate({ scrollTop: 0 }, 1000);
                    this.props.handleChangeEditPacchetto(indexPacchetto, "editable", true);
                });
        }
    }

    onClickNuovoPacchettoButton() {
        console.log(this.componentName + ' onClickNuovoPacchettoButton');
        // Creo la struttura per consintire il sentimento di un nuovo oggetto linea
        this.props.creaNuovoPacchetto().then(
            resolve => {
                let listProdottoPacchetto = this.props.listProdottoPacchetto;
                if (listProdottoPacchetto) {
                    let firstKey = listProdottoPacchetto.length - 1;
                    $('html, body').animate({
                        scrollTop: $("#pacchetto" + firstKey).offset().top - 70
                    }, 1000);
                }
            }
        )
    }

    showPopUP(event) {
        console.log(this.componentName + ' showPopUP');

        let idPacchettoDaEliminare;
        if (event !== undefined && event !== null) {
            idPacchettoDaEliminare = event.currentTarget.id;
        }
        this.setState({ idPacchettoDaEliminare: idPacchettoDaEliminare })

        this.props.showPopUP(!this.props.showPopUp);
    }

    returnToPath() {
        console.log(this.componentName + ' returnToPath');
        let url = this.props.pathToReturn;
        this.props.history.push({ pathname: url });
    }

    validateForm(indexLinea) {

        let validation = new Map();
        let required = ['nomePacchetto', 'descrizionePacchetto'];
        let ProdottoPacchetto = this.props.listProdottoPacchetto[indexLinea];
        if (ProdottoPacchetto) {
            for (let i = 0; i < required.length; i++) {
                if (ProdottoPacchetto[required[i]] === undefined || ProdottoPacchetto[required[i]] === '' || ProdottoPacchetto[required[i]] === null) {
                    validation.set(required[i] + indexLinea, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                   
                }
            }
        }
        
        if (ProdottoPacchetto.listProdottoPacchettoLinea && ProdottoPacchetto.listProdottoPacchettoLinea.length > 0) {
            let percentualeTotale = 0;
            ProdottoPacchetto.listProdottoPacchettoLinea.forEach(element => {
                if (element.percentuale )
                percentualeTotale += parseInt(element.percentuale);

            });
            if (percentualeTotale != 100) {
                this.props.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTO.QUOTA_NON_PUO_ESSERE_MAGGIORE_DI_100', 'La percentuale totale non puo\' essere diversa di 100%'));
                $('html, body').animate({ scrollTop: 0 }, 1000);
                return;
            }
        }

        this.setState({ validation: validation })
        if (validation.size === 0) {
            return true;
        }
        return false;
    }

    render() {
        console.log(this.componentName + "render");
        // if (isNullOrUndefined(this.props.listProdottoLinea)) {
        // }
        let listProdottoPacchetto = this.props.listProdottoPacchetto;

        return (
            <agui.aCardV4>
                <agui.aCardV4Header>
                    <agui.aButton onClick={this.onClickNuovoPacchettoButton} className="btn btn-primary float-right" icon="fas fa-plus" > {i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'Nuovo')} </agui.aButton>
                    < div className='d-flex flex-row ' >
                        {/* <agui.aButton onClick={this.returnToPath} className="btn btn-primary p-2" title={i18n('ARM_CORE_PRODUCT.SHARED', "Indietro")} icon="fas fa-angle-left" /> */}

                        <h3 className="p-2" >{i18n('ARM_CORE_PRODUCT.CLIENTS.CONTRAENTE.PACCHETTI', 'Pacchetti')} </h3>
                    </ div>
                </agui.aCardV4Header>

                <agui.aCardV4Body>
                    <div className="row mt-3">
                        {
                            //dalla lista degli Linea presento a videso solo quello principale
                            listProdottoPacchetto && listProdottoPacchetto.map((pacchetto, index) =>
                                <div key={"mainDiv" + index} id={"pacchetto" + index} className="col-12 col-lg-12 col-md-12 col-sm-12">
                                    <PacchettoCard
                                        key={"pacchetto" + index}
                                        pacchetto={pacchetto}
                                        isListaToEditButton={false}
                                        disabled={!pacchetto.editable}
                                        index={index}
                                        validateForm={this.validateForm}
                                        validation={this.state.validation}
                                        fondiList={this.props.listProdottoLinea}
                                        titleCard={pacchetto.id ? "ID: " + pacchetto.id +" - " + i18n('ARM_CORE_PRODUCT.PRODOTTO.LINEA', 'Nome Pacchetto') + ": " + (pacchetto.nomePacchetto ? pacchetto.nomePacchetto : "") : i18n('ARM_CORE_PRODUCT.PRODOTTO.NUOVA_LINEA', 'Creazione Nuovo Pacchetto')}
                                        onClickModificaLinea={this.onClickModificaPacchetto}
                                        onClickEliminaLinea={this.showPopUP}
                                        onClickAnnullaModifica={this.onClickAnnullaModifica}
                                        onClickSalvaLinea={this.onClickSalvaPacchetto}
                                        downloadDocument={this.props.downloadDocument}/>
                                </div>
                            )
                        }
                        <ConfirmModalDeleteV4
                            show={this.props.showPopUp}
                            testoTitle={i18n('ARM_CORE_PRODUCT.PRODOTTO.ELIMINA.LINEA', 'Confermi di voler Eliminare? ')}
                            deleteOnClick={this.onClickEliminaPacchetto}
                            onClose={this.showPopUP} />
                    </div>
                </agui.aCardV4Body>
            </agui.aCardV4>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPathNameToReturn(path) {
            return dispatch(AppActions.setPathNemeToReturn(path));
        },

        deletePacchetto(idPacchetto) {
            return dispatch(ProdottoActions.deletePacchetto(idPacchetto));
        },

        getListPacchetti(idProdotto) {
            return dispatch(ProdottoActions.getListPacchetti(idProdotto));
        },

        salvaPacchetto(indexPacchetto) {
            return dispatch(ProdottoActions.salvaPacchetto(indexPacchetto));
        },

        creaNuovoPacchetto() {
            return dispatch(ProdottoActions.creaNuovoPacchetto());
        },

        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },

        handleChangeEditPacchetto(index, parametro, value) {
            return dispatch(ProdottoActions.handleChangeEditPacchetto(index, parametro, value));
        },
        addNotify(tipo, messaggio) {
            return dispatch(AppActions.addNotify(tipo, messaggio));
        },

    }
};

function mapStateToProps(state) {
    return {
        showPopUp: state.app.showPopUp,
        prodotto: state.prodotto.detailsProdotto,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListaPacchetto);
